/* eslint-disable react/destructuring-assignment */
import { DataGrid, GridToolbar, frFR } from '@mui/x-data-grid';
import { Card, Typography, IconButton, Button, Dialog, Tooltip,
  DialogActions,
  DialogContent,
  Link,
  DialogContentText,
  CircularProgress,
  Box, } from '@mui/material';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import { ProgressBar } from '../dashboard/session';
import { Link as RouterLink } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import useAuth from '../../hooks/useAuth';
import { useTheme } from '@mui/material/styles';

function renderProgress(params) {
  return <ProgressBar value={Number(params.value)} />;
}
const CampaignResultTable = (props) => {
  const { infoCampaign, setInfoCampaign, handleDeleteCampaign, campaignDelete, setCampaignDelete, setOpenDelete1, openDelete1, isLoading, ...other } = props;
  const { user } = useAuth();
  const theme = useTheme();

  const dialogDelete = (index) => {
    setOpenDelete1(true);
    setCampaignDelete(index);
  };

  const rows = [];

  infoCampaign.forEach((item, index) => {
    rows.push({ id: item.id,
      name: item.name,
      progression: parseFloat(item.progression, 10),
      start_date: item.start_date,
      end_date: item.end_date,
      commercials: item.commercials,
      type: item.type,
      indexId: index,

    });
  });
  // Erreur avec le react/destructuring-assignment donc désactivation d'eslint sur les lignes concernées
  const columns = [
    { field: 'name',
      headerName: 'Nom',
      cellClassName: 'super-app-theme--cell',
      width: 435,
      renderCell: (cellValues) => (
        <Link
          component={RouterLink}
          to={`/dashboard/campaign/${cellValues.row.id}`}
          sx={{ whiteSpace: 'normal',
            width: 310,
            fontWeight: 600,
            color: '#3b82f6',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
              color: '#1d4ed8'
            }
          }}
        >
          {cellValues.row.name}
        </Link>
      ) },
    { field: 'progression', headerName: 'Progression', cellClassName: 'super-app-theme--cell', width: 170, renderCell: renderProgress },
    { field: 'start_date', headerName: 'Date de début', cellClassName: 'super-app-theme--cell', width: 160, renderCell: (cellValues) => (<Typography sx={{ fontWeight: 500 }}>{cellValues.row.start_date !== null ? moment(cellValues.row.start_date).format('DD/MM/YYYY') : ''}</Typography>) },
    { field: 'end_date', headerName: 'Date de fin', cellClassName: 'super-app-theme--cell', width: 160, renderCell: (cellValues) => (<Typography sx={{ fontWeight: 500 }}>{cellValues.row.end_date !== null ? moment(cellValues.row.end_date).format('DD/MM/YYYY') : ''}</Typography>) },
    {
      field: 'commercials',
      headerName: 'Commerciaux',
      cellClassName: 'super-app-theme--cell',
      textOverflow: 'ellipsis',
      width: 370,
      renderCell: (cellValues) => (
        <Tooltip
          followCursor
          enterDelay={500}
          placement="top"
          title={(
            <span style={{ whiteSpace: 'pre-line' }}>
              {' '}
              {cellValues.row.commercials}
            </span>
        )}
        >
          <Typography
            sx={{
              overflow: 'hidden', textOverflow: 'ellipsis', width: '20rem', fontWeight: 500
            }}

          >
            {cellValues.row.commercials}
          </Typography>
        </Tooltip>
      ),
    },
    { field: 'indexId',
      headerName: 'Actions',
      cellClassName: 'super-app-theme--cell',
      width: 100,
      renderCell: (cellValues) => (
        <IconButton
          disabled={user.access_level !== 0}
          onClick={() => dialogDelete(cellValues.row.indexId)}
          sx={{
            color: '#ef4444',
            '&:hover': {
              backgroundColor: 'rgba(239, 68, 68, 0.08)',
            }
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      ) },
  ];
  return (

    <Card
      sx={{
        borderRadius: '24px',
        border: '1px solid rgba(226, 232, 240, 0.8)',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
        '& .super-app-theme--campagne': {
          backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#1e293b'
        },
        '& .super-app-theme--réinjection': {
          backgroundColor: theme.palette.mode === 'light' ? 'rgba(231, 255, 249, 0.4)' : '#1e2e3b'
        },
        '& .MuiDataGrid-root': {
          border: 'none',
        },
        '& .MuiDataGrid-cell': {
          borderBottom: '1px solid rgba(226, 232, 240, 0.6)',
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)',
          borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 700,
          color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
        }
      }}
    >
      <Dialog
        open={openDelete1}
        onClose={() => setOpenDelete1(false)}
      >
        <DialogContent>
          <DialogContentText>
            {`Souhaitez-vous vraiment supprimer la campagne ${infoCampaign[campaignDelete] !== undefined ? infoCampaign[campaignDelete].name : ''} ?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDeleteCampaign(campaignDelete)}
            color="primary"
          >
            Supprimer
          </Button>
          <Button
            onClick={() => setOpenDelete1(false)}
            color="primary"
          >
            Annuler
          </Button>
        </DialogActions>
      </Dialog>
      {!isLoading ? (
        <DataGrid
          {... other}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          autoHeight
          rowHeight={80}
          rows={rows}
          columns={columns}
          pageSize={20}
          rowsPerPageOptions={[30, 100]}
          getRowClassName={(params) => `super-app-theme--${params.row.type}`}
          components={{ Toolbar: GridToolbar }}
        />
      ) : (
        <Box
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Card>
  );
};
CampaignResultTable.propTypes = {
  infoCampaign: PropTypes.object.isRequired,
  setInfoCampaign: PropTypes.func.isRequired,
  handleDeleteCampaign: PropTypes.func.isRequired,
  campaignDelete: PropTypes.object.isRequired,
  setCampaignDelete: PropTypes.func.isRequired,
  openDelete1: PropTypes.object.isRequired,
  setOpenDelete1: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default CampaignResultTable;
